import { throttle } from 'redux-saga/effects';

const DEFAULT_DELAY = 2000;

export function* throttleAction(actionType, workerSaga, delay = DEFAULT_DELAY) {
    yield throttle(delay, actionType, workerSaga);
}
